import { useToast } from '@/components/ui/use-toast';
import { useAppDispatch } from '@/store';
import { logout } from '@/store/auth';
import { useLazySignOutUserQuery } from '@/store/auth/authApi';
import { AccessServiceApiError } from '@/store/user-access-panel/types';
import { useCallback } from 'react';

const useSignOut = () => {
  const { toast } = useToast();

  const dispatch = useAppDispatch();

  const [signOut, signOutResponse] = useLazySignOutUserQuery();

  const handleSignOut = useCallback(async () => {
    toast({
      description: 'You are successfully logged out.'
    });
    const response = await signOut('');
    dispatch(logout());
    if (response.error) {
      const error = response.error as AccessServiceApiError;
      toast({
        title: 'Uh oh, an unexpected error occurred!',
        description: error.data.message,
        variant: 'destructive'
      });
    }
  }, [dispatch, toast]);

  return {
    handleSignOut,
    signOutResponse
  };
};

export default useSignOut;
